import { render, staticRenderFns } from "./LoginLiveSpread.vue?vue&type=template&id=615bb22c&scoped=true&"
import script from "./LoginLiveSpread.vue?vue&type=script&lang=js&"
export * from "./LoginLiveSpread.vue?vue&type=script&lang=js&"
import style0 from "./LoginLiveSpread.vue?vue&type=style&index=0&id=615bb22c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615bb22c",
  null
  
)

export default component.exports